var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,2H3.5C2.7,2,2.1,2.6,2.1,3.4c0,0,0,0,0,0v17.1c0,0.8,0.7,1.4,1.5,1.4c0,0,0,0,0,0h16.9 c0.8,0,1.5-0.6,1.5-1.4c0,0,0,0,0,0V3.4C21.9,2.6,21.3,2,20.5,2C20.5,2,20.5,2,20.5,2z M8.1,18.7h-3v-9h3V18.7z M6.6,8.5L6.6,8.5 C5.7,8.5,5,7.8,5,6.9s0.7-1.6,1.6-1.6c0.9-0.1,1.6,0.5,1.7,1.4S7.8,8.4,6.9,8.5C6.8,8.5,6.7,8.5,6.6,8.5z M18.9,18.7h-3v-4.8 c0-1.2-0.4-2-1.5-2c-0.7,0-1.3,0.4-1.5,1.1c-0.1,0.2-0.1,0.5-0.1,0.7v5h-3c0,0,0-8.2,0-9h3V11c0.6-1,1.6-1.5,2.7-1.5 c2,0,3.4,1.3,3.4,4.1V18.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLight);
export default __webpack_public_path__ + "static/media/linkedin-light.6b028027653b91c4ef60e94db74bc59c.svg";
export { ForwardRef as ReactComponent };